import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TButtonTheme } from '@cian/ui-kit/button/types/TButtonTheme';
import { Button } from '@cian/ui-kit';

import { getIsAuthenticated } from '../../selectors/user';
import { requestAuthentication } from '../../actions/authentication';
import { setNewReviewFormOpen } from '../../actions/newReview';

export interface INewReviewButtonProps {
  size?: 'XS' | 'M' | 'L';
  fill?: TButtonTheme;
  fullWidth?: boolean;
}

export function NewReviewButtonContainer({
  size = 'M',
  fill = 'fill_primary',
  fullWidth = true,
}: INewReviewButtonProps) {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(getIsAuthenticated);

  const handleOpenReviewForm = React.useCallback(() => {
    if (isAuthenticated) {
      dispatch(setNewReviewFormOpen());
    } else {
      dispatch(requestAuthentication({ onSuccess: setNewReviewFormOpen }));
    }
  }, [dispatch, isAuthenticated]);

  return (
    <Button data-testid="NewReviewButton" size={size} fullWidth={fullWidth} theme={fill} onClick={handleOpenReviewForm}>
      Написать отзыв
    </Button>
  );
}
